<template>
  <div>
    <Collapse accordion>
      <Panel :name="item.ClassificationID" v-for="item of lists" :key="item.ClassificationID">
        <Avatar :src="item.IconUrl" />
        {{ item.Classification }}
        <div slot="content">
          单位: {{ item.unit }}
          <Collapse accordion>
            <Panel
              :name="item1.AttributesID"
              v-for="item1 of item.Product_Attributes"
              :key="item1.AttributesID"
            >
              {{ item1.AttributesName }}
                <List slot="content">
                  <ListItem>
                    <Button type="dashed" icon="ios-add" long @click="NewBuildHandleClick(item.ClassificationID,item1.AttributesID)">新增</Button>
                  </ListItem>
                  <ListItem v-for="item2 of item1.Product_Attributes_value" :key="item2.Attributes_value_ID">
                    <ListItemMeta :description="item2.Name" />
                    <ListItemMeta title="类型" :description="item2.typestr" />
                    <template slot="action">
                      <li>
                        <Button
                          type="primary"
                          shape="circle"
                          icon="ios-create-outline"
                          @click="EditHandleClick(item2)"
                        >编辑</Button>
                      </li>
                      <li>
                        <span></span>
                        <Dropdown
                          style="margin-left: 20px"
                          @on-click="SelectHandleClick"
                          @on-visible-change="VisibleChangeHandle(item2)"
                        >
                          <Button type="primary">
                            更多
                            <Icon type="ios-arrow-down"></Icon>
                          </Button>
                          <DropdownMenu slot="list">
                            <DropdownItem name="上移">上移</DropdownItem>
                            <DropdownItem name="下移">下移</DropdownItem>
                            <DropdownItem name="删除">删除</DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </li>
                    </template>
                  </ListItem>
                </List>
            </Panel>
          </Collapse>
        </div>
      </Panel>
    </Collapse>
    <Modal
        title="物料小类编辑"
        v-model="ModalShow"
        :loading="isloading"
        @on-ok="SubmitHandleClick('formCustom')"
        :closable="false">
        <Form :model="info" label-position="top" ref="formCustom" :rules="ruleCustom">
           <FormItem label="名称ID">
               <Input v-model="info.Attributes_value_ID" disabled></Input>
           </FormItem>
           <FormItem label="小类名称" prop="Name">
               <Input v-model="info.Name"></Input>
           </FormItem>
           <FormItem label="类型">
               <Select v-model="info.type">
                 <Option v-for="item in selectionlist" :value="item.value" :key="item.value">{{ item.label }}</Option>
               </Select>
           </FormItem>
        </Form>
    </Modal>
  </div>
</template>

<script>
import { MaterialSubgroupInfo, ChangeMaterialSubgroup, MaterialSubgroupMove } from '../../../api/Materiel'
export default {
  name: 'MaterialSubgroup',
  data () {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写名称'))
      }
      callback()
    }
    return {
      lists: Array,
      ModalShow: false,
      isloading: true,
      info: {
        Attributes_value_ID: '',
        Name: '',
        ClassificationID: '',
        AttributesID: '',
        type: 0,
        typestr: ''
      },
      selectionlist: [
        {
          value: 0,
          label: '常规'
        },
        {
          value: 1,
          label: '非标'
        }
      ],
      State: 0,
      ruleCustom: {
        Name: [{ validator: validateName, trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    this.GetMaterialCategoryData()
  },
  methods: {
    //   获取大类数据
    GetMaterialCategoryData () {
      MaterialSubgroupInfo().then(res => {
        if (res.IsSuccess) {
          this.lists = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 提交中类信息确定
    SubmitHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isloading = false
          this.ModalShow = false
          // this.$Modal.remove()
          this.OKHandleClick()
        } else {
          this.isloading = true
          setTimeout(() => {
            this.isloading = false
          }, 2000)
          this.$Message.error('Fail!')
        }
      })
    },
    // 更新中类信息
    OKHandleClick () {
      ChangeMaterialSubgroup({
        Attributes_value_ID: this.info.Attributes_value_ID,
        ClassificationID: this.info.ClassificationID,
        AttributesID: this.info.AttributesID,
        Name: this.info.Name,
        type: this.info.type,
        operation: this.State
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.GetMaterialCategoryData()
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 点击编辑按钮
    EditHandleClick (item) {
      this.info = item
      this.isloading = true
      this.ModalShow = true
      this.State = 1
    },
    // 点击新增触发事件
    NewBuildHandleClick (ClassificationID, AttributesID) {
      this.info = {
        Attributes_value_ID: '',
        Name: '',
        ClassificationID: ClassificationID,
        type: 0,
        AttributesID: AttributesID
      }
      this.isloading = true
      this.ModalShow = true
      this.State = 0
    },
    // 下拉菜单出现时事件
    VisibleChangeHandle (item) {
      this.info = item
    },
    // 下拉选择时触发
    SelectHandleClick (name) {
      if (name === '删除') {
        this.State = 2
        this.$Modal.confirm({
          title: '删除属性',
          content: '<p>确定删除 "' + this.info.Name + '"这个分类？</p>',
          onOk: () => {
            this.OKHandleClick()
          }
        })
      } else if (name === '上移') {
        MaterialSubgroupMove(this.info.Attributes_value_ID, 1).then((res) => {
          if (res.IsSuccess) {
            this.$Message['success']({
              background: true,
              content: '操作成功'
            })
            this.GetMaterialCategoryData()
          } else {
            this.$Message.error(res.Message)
          }
        })
      } else if (name === '下移') {
        MaterialSubgroupMove(this.info.Attributes_value_ID, 0).then((res) => {
          if (res.IsSuccess) {
            this.$Message['success']({
              background: true,
              content: '操作成功'
            })
            this.GetMaterialCategoryData()
          } else {
            this.$Message.error(res.Message)
          }
        })
      }
    }
  }
}
</script>
<style scoped>
</style>
